module.exports = __webpack_public_path__ + "media/images/digivent/avatars/AVATAR-24-ccbbd27dac81e72ffcaf60430ae72b6a.png";